import Vue from "vue";
import VueRouter from "vue-router";
import SideMenu from "../layouts/SideMenu";
import SimpleMenu from "../layouts/SimpleMenu";
import TopMenu from "../layouts/TopMenu";
import Dashboard from "../views/Dashboard";
import JudgeCases from "../views/JudgeCases";
import OffenceCases from "../views/OffenceCases";
import JudgesCasesCount from "../views/JudgesCasesCount";
import NeverEndingCases from "../views/NeverEndingCases";
import HighProfileCases from "../views/HighProfileCases";
import OffencesCards from "../views/OffencesCards";
import ErrorPage from "../views/ErrorPage";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: SideMenu,
    children: [
      {
        path: "/",
        name: "side-menu-dashboard",
        component: Dashboard
      },
      {
        path: "judges-cases",
        name: "judges-cases",
        component: JudgesCasesCount
      },
      {
        path: "judge-cases/:id",
        name: "judge-cases",
        component: JudgeCases
      },
      {
        path: "offence-cases/:id",
        name: "offence-cases",
        component: OffenceCases
      },
      {
        path: "never-ending-cases",
        name: "never-ending-cases",
        component: NeverEndingCases
      },
      {
        path: "high-profile-cases",
        name: "high-profile-cases",
        component: HighProfileCases
      },
      {
        path: "offences-cards",
        name: "offences-cards",
        component: OffencesCards
      }
    ]
  },
  {
    path: "/simple-menu",
    component: SimpleMenu,
    children: [
      {
        path: "/",
        name: "simple-menu-dashboard",
        component: Dashboard
      }
    ]
  },
  {
    path: "/top-menu",
    component: TopMenu,
    children: [
      {
        path: "/",
        name: "top-menu-dashboard",
        component: Dashboard
      }
    ]
  },
  {
    path: "/error-page",
    name: "error-page",
    component: ErrorPage
  },
  {
    path: "/*",
    component: ErrorPage
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
